import { use } from 'react';

import { LoginFormComponent } from '../login-form/component';
import { OtpVerify } from '../otp-verify/component';
import { LoginContext } from '../provider/context';
import { LoginScreenEnum } from '../provider/enums';

export const DynamicLoginScreen = () => {
  const { screen } = use(LoginContext);

  switch (screen) {
    case LoginScreenEnum.otp:
      return <OtpVerify />;
    default:
      return <LoginFormComponent />;
  }
};
